import { Graphics, IDestroyOptions, Sprite, Texture, Text, TextStyle } from "pixi.js";
import { NFTScrollItem } from "./NFTScrollItem";
import { NFTBuilding } from "by/gamefactory/web3/nfts/NFTBuilding";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { MyWalletResourcePackage } from "../../../resources/MyWalletResourcePackage";
import { BuildingPiggyMultiplier } from "../../BuildingPiggyMultiplier";
import { BuildingAddress } from "../../BuildingAddress";
import { GameFont } from "../../../../../common/GameFont";
import { PurchaseHistory } from "../../../../marketplace/main/models/building/PurchaseHistory";
import { StringFormatExtention } from "../../../../../../../extensions/StringFormatExtention";
import { PiggyClubMultiplier } from "../../../../../common/components/PiggyClubMultiplier";

export class NFTBuildingScrollItem extends NFTScrollItem {
    private static readonly PURCHASE_PRICE = "PURCHASE PRICE: ";

    private readonly borderMask: Graphics;
    private readonly bottomLight: Sprite;
    private readonly initialCostText: Text;
    private readonly piggyMultiplier: BuildingPiggyMultiplier;
    private readonly piggyClubMultiplier: PiggyClubMultiplier;
    private readonly buildingAddress: BuildingAddress;
    private readonly purchaseHistory: Array<PurchaseHistory>;

    public constructor(
        commonResources: CommonResourcesPackage,
        myWalletResources: MyWalletResourcePackage,
        buildingTexture: Texture,
        piggyTexture: Texture,
        piggyClubNftMultiplier: number,
        data: NFTBuilding,
        piggyMultiplier: number,
        buildingAddress: string,
        purchaseHistory: Array<PurchaseHistory>
    ) {
        super(buildingTexture, data);
        this.purchaseHistory = purchaseHistory;
        this.borderMask = new Graphics();
        this.borderMask.beginFill();
        this.borderMask.drawRoundedRect(0, 0, this.image.width, this.image.height, 25);
        this.borderMask.endFill();
        this.addChild(this.borderMask);
        this.image.mask = this.borderMask;

        this.bottomLight = new Sprite(myWalletResources.assets_views_my_wallet_ui_horizontal_light_png);

        this.initialCostText = new Text(NFTBuildingScrollItem.PURCHASE_PRICE, new InitialCostTextStyle());
        this.addChild(this.initialCostText);
        this.updateInitialCost();

        this.piggyClubMultiplier = new PiggyClubMultiplier(commonResources, piggyTexture, `+${((piggyClubNftMultiplier ?? 0) * 100)}%`);
        this.piggyClubMultiplier.visible = !isNaN(piggyClubNftMultiplier) && piggyClubNftMultiplier != null;

        this.piggyMultiplier = new BuildingPiggyMultiplier(commonResources, `+${Math.round(((piggyMultiplier - 1) * 100))}%`);
        this.piggyMultiplier.visible = piggyMultiplier != 1;

        this.buildingAddress = new BuildingAddress(myWalletResources);
        this.buildingAddress.scale.set(0.75);
        this.buildingAddress.updateAddress(buildingAddress);

        this.addChild(
            this.bottomLight,
            this.piggyClubMultiplier,
            this.piggyMultiplier,
            this.buildingAddress
        );

        this.image.on('pointerdown', this.onBuildingClickHandle, this);
        this.image.eventMode = 'static';

        this.bottomLight.position.set((this.image.width - this.bottomLight.width) * 0.5, this.image.height);
        this.buildingAddress.position.set(25);

        if ((!isNaN(piggyClubNftMultiplier) && piggyClubNftMultiplier != null) && purchaseHistory?.length > 0) {
            this.piggyClubMultiplier.position.set(30, this.image.height + 3);
            this.piggyMultiplier.position.set(this.width - this.piggyMultiplier.width - 30, this.image.height + 11);
            this.initialCostText.position.set(this.width * 0.5 - this.initialCostText.width * 0.5, this.image.height + 90);
        } else {
            if ((isNaN(piggyClubNftMultiplier) || piggyClubNftMultiplier == null) && purchaseHistory?.length > 0) {
                this.piggyMultiplier.position.set(this.width * 0.5 - this.piggyMultiplier.width * 0.5, this.image.height + 11);
                this.initialCostText.position.set(this.width * 0.5 - this.initialCostText.width * 0.5, this.image.height + 90);
            } else {
                if ((!isNaN(piggyClubNftMultiplier) && piggyClubNftMultiplier != null) && purchaseHistory?.length == 0) {
                    this.piggyClubMultiplier.position.set(30, this.image.height + 3);
                    this.piggyMultiplier.position.set(this.width - this.piggyMultiplier.width - 30, this.image.height + 11);
                } else {
                    this.piggyMultiplier.position.set(this.width * 0.5 - this.piggyMultiplier.width * 0.5, this.image.height + 11);
                }
            }
        }
    }

    private updateInitialCost(): void {
        this.initialCostText.visible = this.purchaseHistory.length > 0;
        if (this.purchaseHistory?.length > 0) {
            const firstHistory = this.purchaseHistory[0];
            const price = firstHistory.price.usd != null ? firstHistory.price.usd.toFixed(2) : firstHistory.price.mon.toFixed(2);
            const currency = firstHistory.price.usd != null ? "$" : "MON";
            this.initialCostText.text = `${NFTBuildingScrollItem.PURCHASE_PRICE}${currency}${StringFormatExtention.formatWithComma(price)}`;
        }
    }

    private onBuildingClickHandle(): void {
        this.onClick.emit(this);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.image.off('pointerdown', this.onBuildingClickHandle, this);
        super.destroy(options);
    }
}

class InitialCostTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fill: [
                "#a8fd09",
                "#15ce14"
            ],
            fontSize: 36,
            align: "center"
        });
    }
}
